
import axios from "axios"
import {defineComponent} from 'vue'
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Message from "primevue/message";
import {lookupURL} from "@/config/app-settings";

export default defineComponent({
  name: "PersonPicker",
  components: {InputText, Button, Message},
  data() {
    return {
      options: [],
      isActive: false,
      personFound: 'noSelection' as 'no' | 'yes' | 'noSelection',
      email: '',
      persons: [] as any[],
      addedPersons: [] as any[]
    }
  },
  props: {
    api: {type: String, required: true},
    name: {type: String, required: true},
    value: {type: Array, required: true},
  },
  methods: {
    clearPersonList() {
      this.personFound = 'noSelection'
      this.addedPersons = []
      this.persons = []
      this.$emit('select', {key: this.name, value: null})
    },

    search(value: string) {
      axios.get(this.api + '?email=' + value)
          .then((res) => {
            if (res.data.length > 0) {
              this.personFound = 'yes'
              !this.persons.includes(res.data[0].personId) ? this.persons.push(res.data[0].personId) : {}
              if (res.data[0].email) {
                !this.addedPersons.includes(res.data[0].email) ? this.addedPersons.push(res.data[0].email) : {}
              } else {
                !this.addedPersons.includes(res.data[0].firstName + ' ' + res.data[0].lastName) ? this.addedPersons.push(res.data[0].firstName + ' ' + res.data[0].lastName) : {}
              }

              this.$emit('select', {key: this.name, value: this.persons.flat()})
              this.email = ''
            } else {
              this.$emit('select', {key: this.name, value: this.persons.flat()})
              this.personFound = 'no'
            }
          }).catch(() =>
          this.personFound = 'no'
      )

    },

    validEmail() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.email).toLowerCase());
    }
  },
  watch: {
    persons() {
      this.$emit('select', {key: this.name, value: this.persons.flat()})
    }
  },
  beforeMount() {

    if (this.value) {
      this.persons.push(this.value)
      this.persons[0].forEach((p: number) =>  {
        axios.get(lookupURL + 'personById?personId=' + p)
            .then((res) => {
              this.addedPersons.push(res.data[0].email)
              this.personFound = 'yes'
            }).catch(() =>
            this.personFound = 'no'
        )
      })
    } else {
      // add logged-in user as default leg/det/vis
      this.persons.push(this.$store.state.user.personId)
      this.addedPersons.push(this.$store.state.user.email)
      this.personFound = 'yes'
    }
    this.$emit('select', {key: this.name, value: this.persons.flat()})

  }

})
